import React from "react"
import PropTypes from "prop-types"
import { Button as ReactStrapButton, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import cloneDeep from "lodash/cloneDeep"
import styled from "styled-components"
import { Button } from "../../themed-html-components"
import Tabs from "../../layout/navigation/Tabs"
import * as customReportApiActions from "../../../state/actions/customReportApiActions"
import {
  CustomReportLocationSelection,
  CustomReportEmployeeSelection
} from "./LocationsEmployeesSelection"
import PersonCardShape from "../../../state/shapes/PersonCardShape"

const IntroArea = styled.div`
  margin-bottom: 1em;
`

const SelectionContainer = styled.div`
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  min-height: 200px;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top: none;
  padding-top: 1em;
  padding-left: 1em;
  padding-right: 1em;
`

const tabs = [
  {
    id: 1,
    name: "CustomReport.LocationsEmployeeSelection.ModalLocationTab"
  },
  {
    id: 2,
    name: "CustomReport.LocationsEmployeeSelection.ModalEmployeeTab"
  }
]
const bigModal = {
  maxWidth: "1200px"
}

class LocationsEmployeeSelectionModal extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    closePopup: PropTypes.func.isRequired,
    updateSelections: PropTypes.func.isRequired,
    employeeSearch: PropTypes.func.isRequired,
    resetEmployeeSearch: PropTypes.func.isRequired,
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired
    }).isRequired,
    selectedEmployees: PropTypes.arrayOf(PropTypes.shape(PersonCardShape)).isRequired,
    selectedLocations: PropTypes.arrayOf(PropTypes.number).isRequired,
    searchResults: PropTypes.arrayOf(PropTypes.shape(PersonCardShape))
  }

  static defaultProps = {
    searchResults: null
  }

  state = {
    activeTab: 1,
    selectedEmployees: this.props.selectedEmployees,
    selectedLocations: this.props.selectedLocations,
    updatedSelectedLocations: this.props.selectedLocations.map(x => x.toString())
  }

  onSearchChange = searchTerm => {
    this.props.employeeSearch(searchTerm)
  }

  employeeSelection = employeeId => {
    const employee = this.props.searchResults.filter(emp => {
      return emp.employeeId === employeeId
    })

    this.setState({ selectedEmployees: [...this.state.selectedEmployees, ...employee] })
  }

  includeDirectReportsChangeHandler = (employeeId, includeDirectReportsValue) => {
    const employeesCopy = cloneDeep(this.state.selectedEmployees)
    const index = employeesCopy.findIndex(emp => {
      return emp.employeeId === employeeId
    })

    employeesCopy[index].includeDirectReports = includeDirectReportsValue
    this.setState({ selectedEmployees: employeesCopy })
  }

  employeeRemoved = employeeId => {
    const updatedCollection = this.state.selectedEmployees.filter(employee => {
      return employee.employeeId !== employeeId
    })

    this.setState({ selectedEmployees: updatedCollection })
  }

  locationsChanged = locations => {
    this.setState({ updatedSelectedLocations: locations })
  }

  closeModal = () => {
    this.props.resetEmployeeSearch()
    this.props.closePopup()
  }

  tabClicked = newActiveTab => {
    this.setState({ activeTab: newActiveTab.id })
  }

  submitChanges = () => {
    // Before submitting our changes we need to convert our string location ids
    // into numbers.
    let selectedLocationIds = []
    if (this.state.updatedSelectedLocations && this.state.updatedSelectedLocations.length > 0) {
      selectedLocationIds = this.state.updatedSelectedLocations.map(x => parseInt(x, 10))
    }
    this.props.updateSelections(this.state.selectedEmployees, selectedLocationIds)
    this.closeModal()
  }

  render() {
    const { t, theme, filterState } = this.props // eslint-disable-line react/prop-types

    return (
      <div>
        <Modal isOpen toggle={this.closeModal} className="modal-lg" style={bigModal}>
          <ModalHeader toggle={this.closeModal}>
            {t("CustomReport.LocationsEmployeeSelection.ModalTitle")}
          </ModalHeader>
          <ModalBody>
            <IntroArea>
              <em>{t("CustomReport.LocationsEmployeeSelection.ModalIntro")}</em>
            </IntroArea>
            <div className="row">
              <div className="col-md-12">
                <Tabs
                  tabDetails={tabs}
                  onTabChange={this.tabClicked}
                  activeTab={this.state.activeTab}
                />
              </div>
            </div>
            <SelectionContainer>
              {this.state.activeTab === 1 ? (
                <CustomReportLocationSelection
                  treeData={filterState.fields.adminLocations.options}
                  selectedValues={this.state.selectedLocations}
                  theme={theme}
                  locationsChanged={this.locationsChanged}
                />
              ) : (
                <CustomReportEmployeeSelection
                  theme={theme}
                  searchResults={this.props.searchResults}
                  onSearchChange={this.onSearchChange}
                  onEmployeeSelection={this.employeeSelection}
                  employeeRemoved={this.employeeRemoved}
                  selectedEmployees={this.state.selectedEmployees}
                  includeDirectReportsChangeHandler={this.includeDirectReportsChangeHandler}
                />
              )}
            </SelectionContainer>
          </ModalBody>
          <ModalFooter>
            <Button inverted onClick={this.submitChanges}>
              {t("Common.Submit")}
            </Button>{" "}
            <ReactStrapButton color="secondary" onClick={this.closeModal}>
              {t("Common.Cancel")}
            </ReactStrapButton>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

function mapState(state) {
  return {
    theme: state.userDetail.theme,
    filterState: state.filters,
    searchResults: state.customReport.employeeSearchResults
  }
}

function mapDispatch(dispatch) {
  return {
    employeeSearch: searchString => {
      dispatch(customReportApiActions.employeeSearch(searchString))
    },
    resetEmployeeSearch: () => {
      dispatch(customReportApiActions.resetEmployeeSearch())
    }
  }
}

export default compose(translate(), connect(mapState, mapDispatch))(LocationsEmployeeSelectionModal)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/LocationsEmployeeSelectionModal.jsx